<template>
  <div class="">
    <Button 
      label=""
      class=""
      size="small"
      severity="warning"
      icon="pi pi-pencil"
      @click="openModal()"
      v-tooltip.left="`Update Kategori`"
    />
    <Dialog v-model:visible="visible" :modal="true" class="p-fluid" header="Update Kategori" :breakpoints="{ '960px': '80vw' }" :style="{ width: '50vw' }" @hide="hideModal()">
      <div class="" style="">
        <div class="flex flex-column gap-2 mb-2">
          <label for="jenis_kategori">Jenis Kategori</label>
          <Dropdown 
            v-model="dataForm.jenis_kategori" 
            :options="$store.state.data_static.jenis_kategori" 
            optionLabel="text" 
            optionValue="value" 
            placeholder="piilh jenis kategori" class="w-full" 
            :class="{'p-invalid': v$.dataForm.jenis_kategori.$invalid}" 
          />
        </div>
        <div class="flex flex-column gap-2 mb-2">
          <label for="kode_kategori">Kode Kategori</label>
          <InputText id="kode_kategori" v-model="dataForm.kode_kategori" aria-describedby="kode_kategori-help" :class="{'p-invalid': v$.dataForm.kode_kategori.$invalid}"/>
        </div>
        <div class="flex flex-column gap-2">
          <label for="nama_kategori">Nama Kategori</label>
          <InputText id="nama_kategori" v-model="dataForm.nama_kategori" aria-describedby="nama_kategori-help" :class="{'p-invalid': v$.dataForm.nama_kategori.$invalid}"/>
        </div>
      </div>
      <template #footer>
        <div class="flex justify-content-end">
          <Button 
            label="Save"
            class=""
            size="small"
            :disabled="!isValid && !isDirty"
            v-tooltip.left="`save`"
            @click="submit()"
          />
        </div>
      </template>
    </Dialog>
  </div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
export default {
  props: [ 'data' ],
  emits: [ 'refresh' ],
  components: {
  },
  setup () {
    return { v$: useVuelidate() }
  },
  data() {
    return {
      visible: false,
      dataForm: {
        jenis_kategori: null,
        nama_kategori: null,
        kode_kategori: null,
      },
    };
  },
  computed: {
    isValid() {
      return !this.v$.dataForm.$invalid;
    },
    isDirty() {
      return this.v$.dataForm.$anyDirty;
    },
  },
  validations () {
    return {
      dataForm: {
        jenis_kategori: { required },
        nama_kategori: { required },
        kode_kategori: { required },
      }
    }
  },
  mounted() {
  },
  methods: {
    openModal(){
      const vm = this
      vm.visible = true
      vm.dataForm = JSON.parse(JSON.stringify(vm.data))
      vm.v$.$reset();
    },
    hideModal(){
      const vm = this
      vm.visible = false
    },
    async submit(){
      const vm = this
      const res = await vm.$axios.post('kategori/update', vm.dataForm)
      if(res.data.status == 200){
        vm.$emit('refresh')
        vm.$toast.add({ severity: 'success', summary: 'Konfirmasi', detail: 'Berhasil Update Kategori', life: 3000 });
        vm.visible = false
      }else{
        vm.$toast.add({ severity: 'error', summary: 'Konfirmasi', detail: 'Gagal Update Kategori', life: 3000 });
      }
    },
  },
};
</script>